// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1VmtI","bigColWidth":"Table_bigColWidth__267h6","biggerColWidth":"Table_biggerColWidth__2nOhp","row":"Table_row__1c4mv","col":"Table_col__3kDi_"};